import { Box, Typography } from '@mui/material';
import DownloadPDFModal from '../../../../components/DownloadPDFModal/DownloadPDFModal';
import PdfHeader from '../../../../components/DownloadPDFModal/PdfHeader';
import ChartLayout from './Charts';

interface DownloadReportsPdfProps {
  isOpen: boolean;
  dealName: string;
  handleClose: () => void;
  tabbedCharts: Record<string, any> | undefined;
  tab: string;
  filters: { dates: string[]; gameId: string };
  showDefinitionSidePanel: () => void;
  submoduleId: string;
}

const UnderwritingDownloadPdf: React.FC<DownloadReportsPdfProps> = ({
  isOpen,
  dealName,
  handleClose,
  tabbedCharts,
  tab,
  filters,
  showDefinitionSidePanel,
  submoduleId,
}) => {
  const getDefinitions = () => {
    const allDefinitions = tabbedCharts?.[tab].charts
      .map((chart: any) => JSON.parse(chart.metadata).definitions)
      .flat();

    const uniqueDefinitions = Array.from(
      new Map(allDefinitions?.map((def: any) => [def.label, def])).values(),
    ).sort((a: any, b: any) => a.label.localeCompare(b.label));

    return uniqueDefinitions;
  };

  const getDateRange = () => {
    // filters.dates is an array of strings dates, sort them
    const sortedDates = filters.dates.sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
    const startDate = sortedDates[0];
    const endDate = sortedDates[sortedDates.length - 1];
    return `${startDate} to ${endDate}`;
  };

  return (
    <DownloadPDFModal
      isOpen={isOpen}
      handleClose={handleClose}
      fileName={`${tabbedCharts?.[tab]?.label}_${filters.gameId}.pdf`}
      isSinglePage
      delay={2000}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: 'auto',
          }}
        >
          <PdfHeader />
        </Box>
        <Box
          sx={{
            padding: '1.25rem',
            backgroundColor: '#FFFFFF',
            borderRadius: '0.75rem',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Manrope, sans-serif',
              fontWeight: 700,
              fontSize: '1.375rem',
              color: '#1B1C17',
            }}
          >
            {`${tabbedCharts?.[tab]?.label}`}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Manrope, sans-serif',
              fontWeight: 700,
              fontSize: '1rem',
              color: '#1B1C17',
            }}
          >
            {getDateRange()}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Manrope, sans-serif',
              fontWeight: 700,
              fontSize: '1.5rem',
              color: '#6C6C6C',
            }}
          >
            {dealName}
          </Typography>
        </Box>
        <Box mt={'18px'} display={'flex'} flexDirection={'column'} gap={'1rem'}>
          {/* <UnderwrittingNotes /> */}

          {/* Charts */}
          {(tabbedCharts || {})[tab]?.charts.map((item: any) => (
            <ChartLayout
              filters={filters}
              chartTitle={item.name}
              showDefinitionSidePanel={() => {
                showDefinitionSidePanel();
              }}
              chartType={item.chartType}
              submoduleId={submoduleId}
              chartId={item.id}
              renderForExport
            />
          ))}
        </Box>
        <Box
          sx={{
            width: '100%',
            padding: '0.875rem',
            backgroundColor: '#FFF',
            borderRadius: '0.75rem',
            marginBottom: '0.75rem',
            marginTop: '1rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
          }}
        >
          <Typography
            sx={{
              fontSize: '1rem',
              fontWeight: 700,
              color: '#162936',
              lineHeight: '1.375rem',
            }}
          >
            Definitions
          </Typography>
          {getDefinitions().map((def: any) => (
            <Box key={def.label}>
              <Typography
                sx={{
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  color: '#162936',
                  lineHeight: '1.25rem',
                }}
              >
                {def.label}
              </Typography>
              <Typography
                sx={{
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  color: '#6C6C6C',
                  lineHeight: '1.25rem',
                }}
              >
                {def.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </DownloadPDFModal>
  );
};

export default UnderwritingDownloadPdf;
